import { jsx } from "panel";
import { ButtonEl } from "common/components/button";
import { ButtonTheme } from "common/components/button/constants";
import { AuthContainerEl } from "common/widgets/auth-container";
import { SvgIconEl } from "common/components/svg-icon";
import { CheckboxEl } from "common/components/checkbox";
export function template() {
  var _a;
  return /* @__PURE__ */ jsx("div", null, /* @__PURE__ */ jsx(AuthContainerEl, {
    attrs: { "show-footer-links": true }
  }, /* @__PURE__ */ jsx("div", {
    sel: ".auth-form",
    attrs: { slot: `auth-form-slot` }
  }, /* @__PURE__ */ jsx("form", {
    attrs: {
      action: `/security/twofactor/redirect/`,
      method: `post`
    },
    hook: {
      insert: this.helpers.onInsert
    }
  }, /* @__PURE__ */ jsx("div", {
    sel: ".download-icon-wrapper"
  }, /* @__PURE__ */ jsx(SvgIconEl, {
    attrs: { icon: `install` }
  })), /* @__PURE__ */ jsx("h1", {
    sel: ".auth-form-title"
  }, "Save Your Recovery Codes"), /* @__PURE__ */ jsx("div", {
    sel: ".recovery-code-form-subtitle"
  }, "These recovery codes will be required if you are unable to access your authentication app. This is the only time you are able to save them.", ` `, /* @__PURE__ */ jsx("a", {
    sel: ".recovery-learn-more-link",
    attrs: {
      href: `https://docs.mixpanel.com/docs/admin/two-factor-authentication`,
      target: `_blank`
    }
  }, "Learn more")), /* @__PURE__ */ jsx("div", {
    sel: ".recovery-codes-block"
  }, (_a = this.attr(`original-recovery-codes`)) == null ? void 0 : _a.map((code) => /* @__PURE__ */ jsx("div", {
    sel: ".single-code"
  }, code))), /* @__PURE__ */ jsx("div", {
    sel: ".buttons"
  }, /* @__PURE__ */ jsx(ButtonEl, {
    sel: ".button-item",
    attrs: {
      theme: ButtonTheme.Secondary,
      icon: this.state.copyInProgress && `spinner`,
      disabled: this.state.copyInProgress
    },
    on: { click: this.helpers.onClickCopyButton }
  }, "Copy"), /* @__PURE__ */ jsx(ButtonEl, {
    sel: ".button-item",
    attrs: {
      theme: ButtonTheme.Secondary,
      icon: this.state.downloadInProgress && `spinner`,
      disabled: this.state.downloadInProgress
    },
    on: { click: this.helpers.onClickDownloadButton }
  }, /* @__PURE__ */ jsx("a", {
    attrs: {
      id: `download-link`,
      href: `data:text/plain;charset=utf-8,` + encodeURIComponent(this.attr(`original-recovery-codes`).join(`,`)),
      download: `Mixpanel-Recovery-Codes.txt`
    }
  }), "Download")), /* @__PURE__ */ jsx("div", {
    sel: ".checkbox-wrapper"
  }, /* @__PURE__ */ jsx(CheckboxEl, {
    sel: ".acknowledgement-checkbox",
    attrs: { checked: this.state.acknowledged },
    on: {
      click: () => {
        if (!this.state.acknowledged) {
          this.helpers.checkCheckbox();
        } else {
          this.helpers.uncheckCheckbox();
        }
      }
    }
  }), /* @__PURE__ */ jsx("div", {
    sel: ".acknowledgement-text"
  }, "I acknowledge I have saved my recovery codes", /* @__PURE__ */ jsx("span", null, "*"))), /* @__PURE__ */ jsx("div", {
    sel: ".error-message",
    style: { visibility: this.state.error ? `visible` : `hidden` }
  }, "Confirm you have saved your recovery codes"), /* @__PURE__ */ jsx(ButtonEl, {
    sel: ".login-button",
    attrs: {
      theme: ButtonTheme.Primary,
      icon: this.state.loggingIn && `spinner`,
      disabled: this.state.loggingIn
    },
    on: { click: this.helpers.onClickLoginButton }
  }, "Log In")))));
}
